<template>
  <div>
    <vxe-grid
      ref="freightDeductionTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      row-id="freightDeductionCode"
      row-config.keyField
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkMethod: checCheckboxkMethod,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="onCellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentScmDeductionStatus === 'D'
              ? 'danger'
              : row.shipmentScmDeductionStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ row.v_shipmentScmDeductionStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { code: row.freightDeductionCode },
                  query: { freightDeductionNo: row.freightDeductionNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M') && row.shipmentScmDeductionStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { code: row.freightDeductionCode },
                  query: { freightDeductionNo: row.freightDeductionNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D') && row.shipmentScmDeductionStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="row.shipmentScmDeductionStatus === 'N'"
          >
            <i
              class="el-icon-check tool-btn"
              @click="$emit('submitReview', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del({ freightDeductionCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .shipmentFreightDeductionDelApi({ freightDeductionCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (200 !== status) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckBoxRow() {
      this.$refs.freightDeductionTable.clearCheckboxRow()
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return
      this.$refs.freightDeductionTable.toggleCheckboxRow(row)
      const data = this.$refs.freightDeductionTable.getCheckboxRecords(true)
      this.$emit('checkbox-change', data)
    },
    clearCheckboxRows() {
      this.$refs.freightDeductionTable.removeCheckboxRow()
    },
    checCheckboxkMethod({ row }) {
      return row.shipmentScmDeductionStatus === 'N'
    },
  },
}
</script>
